<script setup lang="ts">
export interface CreditSummaryItem {
	label: string;
	value: string;
	isFullWidth?: boolean;
}

defineProps<{
	headline: CreditSummaryItem;
	items: CreditSummaryItem[];
}>();
</script>

<template>
	<div class="grid grid-cols-2 gap-4 rounded-xs bg-[#1F1F1F] p-4.5">
		<div class="col-span-full">
			<div class="text-[13px] text-[#A3A3A3]">{{ headline.label }}</div>
			<div
				class="font-[Inter,sans-serif] text-[36px] leading-[1.15] font-normal tracking-[-0.02em]"
			>
				{{ headline.value }}
			</div>
		</div>
		<div
			v-for="item in items"
			:key="item.label"
			:class="{ 'col-span-full': item.isFullWidth }"
		>
			<div class="text-[12px] text-[#A3A3A3]">{{ item.label }}</div>
			<div class="text-[16px] font-medium">{{ item.value }}</div>
		</div>
	</div>
</template>
